"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyAccordion = void 0;

const faAngleDown_1 = require("@fortawesome/pro-regular-svg-icons/faAngleDown");

const react_fontawesome_1 = require("@fortawesome/react-fontawesome");

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const StyledAccordion = (0, material_1.styled)(material_1.Accordion, {
  shouldForwardProp: prop => prop !== "styleName"
})(({
  theme,
  styleName
}) => ({
  [`&.${material_1.accordionClasses.root}`]: isMinimalisticStyle(styleName) ? {
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: "none",
    '&$expanded': {
      margin: "0"
    },
    '&:before': {
      backgroundColor: 'rgba(255, 255, 255, 0)'
    }
  } : {},
  [`&.${material_1.accordionClasses.expanded}`]: {
    "&:before": {
      opacity: "unset"
    }
  }
}));
const StyledAccordionSummary = (0, material_1.styled)(material_1.AccordionSummary, {
  shouldForwardProp: prop => prop !== "styleName"
})(({
  styleName
}) => ({
  [`&.${material_1.accordionSummaryClasses.root}`]: isMinimalisticStyle(styleName) ? {
    margin: 0,
    paddingLeft: 0,
    paddingRight: 0
  } : {},
  [`& .${material_1.accordionSummaryClasses.content}`]: isMinimalisticStyle(styleName) ? {
    margin: "0",
    "&$expanded": {
      margin: "0"
    }
  } : {
    justifyContent: "space-between",
    alignItems: "center",
    margin: "5px 0",
    "&$expanded": {
      margin: "10px 0"
    }
  }
}));
const StyledExpandIcon = (0, material_1.styled)(react_fontawesome_1.FontAwesomeIcon, {
  shouldForwardProp: prop => prop !== "styleName"
})(({
  styleName
}) => isMinimalisticStyle(styleName) ? {
  margin: "0",
  "&$expanded": {
    margin: "0"
  }
} : {
  margin: "0 4px"
});
const StyledAccordionDetails = (0, material_1.styled)(material_1.AccordionDetails, {
  shouldForwardProp: prop => prop !== "styleName"
})(({
  styleName
}) => ({
  [`&.${material_1.accordionDetailsClasses.root}`]: isMinimalisticStyle(styleName) ? {
    paddingLeft: 0,
    paddingRight: 0
  } : {
    flexDirection: "column",
    padding: "0"
  }
}));

function isMinimalisticStyle(style = "regular") {
  return style.toLowerCase() === "minimalistic";
}

const SskyAccordion = props => {
  var _a, _b;

  const header = typeof props.header === "string" ? react_1.default.createElement(material_1.Typography, null, props.header) : props.header;
  return react_1.default.createElement(StyledAccordion, {
    className: props.className,
    disabled: props.disabled,
    expanded: props.expanded,
    id: props.id,
    "data-testid": props.dataTestId || `testId-${props.id || props.header}`,
    "data-tracking-id": props.dataTrackingId || `tracking-id-${props.id || props.header}`,
    onChange: props.onChange,
    TransitionProps: {
      mountOnEnter: (_a = props.mountOnEnter) !== null && _a !== void 0 ? _a : true,
      unmountOnExit: (_b = props.unmountOnExit) !== null && _b !== void 0 ? _b : true
    },
    square: isMinimalisticStyle(props.styleName),
    styleName: props.styleName
  }, react_1.default.createElement(StyledAccordionSummary, {
    className: props.classNameSummary,
    expandIcon: react_1.default.createElement(StyledExpandIcon, {
      icon: faAngleDown_1.faAngleDown,
      styleName: props.styleName
    }),
    styleName: props.styleName
  }, header), react_1.default.createElement(StyledAccordionDetails, {
    className: props.classNameDetails,
    styleName: props.styleName
  }, props.children || react_1.default.createElement("div", null)), props.showSaveCancelButtons && react_1.default.createElement("div", null, react_1.default.createElement(material_1.Divider, null), react_1.default.createElement(material_1.AccordionActions, null, react_1.default.createElement(material_1.Button, {
    size: "small",
    onClick: props.onCancel
  }, "Cancel"), react_1.default.createElement(material_1.Button, {
    size: "small",
    color: "primary",
    onClick: props.onSave
  }, "Save"))));
};

exports.SskyAccordion = SskyAccordion;
SskyAccordion.defaultProps = {
  addMarginsWhenExpanded: true
};
exports.default = react_1.default.memo(SskyAccordion);